import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countrySelect", "stateSelect", "stateTextInput"]

  static values = {
    statesByCountry: Object,
    statePrompt: String,
    required: { type: Boolean, default: true }
  }

  connect() {
    this.updateStates()
  }

  updateStates() {
    const country = this.countrySelectTarget.value
    const selectedValue = this.stateSelectTarget.dataset.selectedValue || this.stateSelectTarget.value
    const states = this.statesByCountryValue[country] || []

    if (states.length === 0) {
      this.stateSelectTarget.innerHTML = ""
      this.stateSelectTarget.disabled = true
      this.stateSelectTarget.required = false
      this.stateSelectTarget.classList.add("hidden")

      this.stateTextInputTarget.disabled = false
      this.stateTextInputTarget.required = this.requiredValue
      this.stateTextInputTarget.classList.remove("hidden")
      return
    }

    this.stateTextInputTarget.disabled = true
    this.stateTextInputTarget.required = false
    this.stateTextInputTarget.classList.add("hidden")

    this.stateSelectTarget.disabled = false
    this.stateSelectTarget.required = this.requiredValue
    this.stateSelectTarget.classList.remove("hidden")
    this.stateSelectTarget.innerHTML = ""

    if (this.statePromptValue) {
      const placeholder = document.createElement("option")
      placeholder.value = ""
      placeholder.textContent = this.statePromptValue
      this.stateSelectTarget.appendChild(placeholder)
    }

    states.forEach((state) => {
      const option = document.createElement("option")
      option.value = state
      option.textContent = state
      option.selected = state === selectedValue
      this.stateSelectTarget.appendChild(option)
    })

    if (!states.includes(selectedValue)) {
      this.stateSelectTarget.value = this.statePromptValue ? "" : (states[0] || "")
      this.stateSelectTarget.dataset.selectedValue = this.stateSelectTarget.value
    }
  }
}
